<template>
<div class="treemap-chart">
  <div id="popup" style="display: none;" v-tippy-html>
    <div v-if="hoveredNode" class="popover-content">
      <h3>{{hoveredNode.data.name}}</h3>
      <h4>Presupuesto ejecutado</h4>
      <div class="amount">{{moneyFormatter(hoveredNode.value)}}</div>
      <div
        class="percentage"
      >{{numeral(hoveredNode.value/hoveredNode.parent.value).format('0.00%')}} del ppto total</div>
    </div>
  </div>

  <svg :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
    <g
      v-for="d in computedData.children"
      :transform="'translate('+d.x0+','+d.y0+')'"
      @click="push(d)"
      @mouseenter="hoveredNode = d"
      class="cell"
      v-tippy="{html: '#popup', followCursor: true, arrow: true, animation: 'fade'}"
    >
      <rect :width="d.x1 - d.x0" :height="d.y1 - d.y0" :fill="color(d.data.name)"></rect>
      <foreignObject :key="JSON.stringify(d.data)" :width="d.x1 - d.x0" :height="d.y1 - d.y0">
        <body>
          <div class="content">
            <div class="text" v-if="d.x1 - d.x0 > 75 && d.y1 - d.y0 > 75">
              <div class="name">{{d.data.name}}</div>
              <div v-if="!ravest" class="size">{{numeral(d.value / d.parent.value).format('0.00%')}}</div>
            </div>
          </div>
        </body>
      </foreignObject>
    </g>
  </svg>
</div>
</template>
<style lang="scss">
.treemap-chart {
    svg {
        width: 100%;
        height: auto;
        .cell {
            cursor: pointer;
            transition: all ease 1s;
            rect {
                transition: all ease 1s;
            }
            foreignObject {
                body {
                    width: 100%;
                    height: 100%;
                    background: transparent;
                    .content {
                        width: 100%;
                        height: 100%;
                        color: white;
                        line-height: 1;
                        padding: 10px;
                        .text {
                            width: 100%;
                            height: 100%;
                            .name {
                                font-size: 100%;
                                margin-bottom: 10px;
                            }
                            .size {
                                font-size: 175%;
                                line-height: 0.5;
                                .small {
                                    font-size: 40%;
                                    text-transform: uppercase;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
<script>
import * as d3 from 'd3';
import numeral from 'numeral';
import moneyFormatter from '../../Methods/MoneyFormatter';
import textFit from 'textfit';

export default {
    data: function() {
        return {
            hoveredNode: null,
            node: null
        };
    },
    props: {
        data: {},
        breadcrumb: {},
        width: { default: 1110 },
        height: { default: 686 },
        colors: { default: null },
        ravest: { default: false }
    },
    watch: {
        data: function(data) {
            /*
                console.log(data);
                data.children.forEach(function(d){
                    d.ratio = d.value / data.value;
                });
                */

            this.node = data;
            if (this.breadcrumb.length === 0)
                this.breadcrumb.push(this.computedData);
        },
        computedData: function() {
            this.$nextTick(() => {
                textFit(
                    this.$el.querySelectorAll(
                        'foreignObject body .content .text'
                    ),
                    {
                        minFontSize: 6,
                        maxFontSize: 16
                    }
                );
            });
        }
    },
    computed: {
        color: function() {
            let colors = [
                '#253494',
                '#081D58',
                '#34385E',
                '#3455DB',
                '#1E90FF',
                '#DB0A5B',
                '#8A2BE2',
                '#49006A',
                '#7A0177',
                '#DC143C',
                '#005500',
                '#008000',
                '#3455DB',
                '#A745AD',
                '#DC2A2A',
                '#28A228',
                '#B22222',
                '#7C0180'
            ];
            if (this.colors) colors = this.colors;

            return d3.scaleOrdinal(colors);
        },
        treemap: function() {
            return d3
                .treemap()
                .tile(d3.treemapResquarify)
                .size([this.width, this.height])
                .round(true)
                .paddingInner(4);
        },
        computedData: function() {
            if (!this.node) return [];

            const root = d3
                .hierarchy(this.node)
                //.eachBefore(function(d) { d.data.id = (d.parent ? d.parent.data.id + "." : "") + d.data.id; })
                .sum(function(d) {
                    return d.size;
                })
                .sort(function(a, b) {
                    return b.height - a.height || b.value - a.value;
                });

            this.treemap(root);

            return root;
        }
    },
    methods: {
        numeral: numeral,
        moneyFormatter: moneyFormatter,
        push: function(n) {
            //this.$emit('pushed', n);

            if (!n.data.children) {
                this.detailClicked(n);
                return;
            }

            this.breadcrumb.push(n);
            this.node = n.data;
        },
        pop: function() {
            if (this.breadcrumb.length <= 1) return;

            this.breadcrumb.pop();
            this.node = this.breadcrumb[this.breadcrumb.length - 1].data;
        },
        detailClicked: function(d) {
            this.$emit('detail-clicked', d);
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/Treemap.vue